(function () {
  // ---------- In-cart badge updater ----------
  let cartFetchInFlight = null;
  let refreshTimer = null;

  function pluralize(n, one, many) {
    return n === 1 ? one : many;
  }

  async function fetchCart() {
    if (cartFetchInFlight) return cartFetchInFlight;

    cartFetchInFlight = fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then((r) => {
        if (!r.ok) throw new Error('Failed to fetch cart.js');
        return r.json();
      })
      .finally(() => {
        cartFetchInFlight = null;
      });

    return cartFetchInFlight;
  }

  function getProductQtyMap(cart) {
    const map = new Map();
    (cart.items || []).forEach((item) => {
      const pid = item.product_id;
      const qty = item.quantity || 0;
      map.set(pid, (map.get(pid) || 0) + qty);
    });
    return map;
  }

  function renderInCartBadges(cart) {
    const map = getProductQtyMap(cart);
    document.querySelectorAll('[data-in-cart-for-product]').forEach((el) => {
      const pid = Number(el.getAttribute('data-in-cart-for-product'));
      const qty = map.get(pid) || 0;

      if (qty > 0) {
        el.textContent = `${qty} ${pluralize(qty, 'copy', 'copies')} in cart`;
        el.hidden = false;
      } else {
        el.textContent = '';
        el.hidden = true;
      }
    });
  }

  async function refreshInCartBadges() {
    try {
      const cart = await fetchCart();
      renderInCartBadges(cart);
    } catch (_) {
      // silent
    }
  }

  function scheduleRefresh() {
    if (refreshTimer) clearTimeout(refreshTimer);
    refreshTimer = setTimeout(() => {
      refreshTimer = null;
      refreshInCartBadges();
    }, 120);
  }

  // Patch fetch to detect cart-changing requests across the theme
  const _fetch = window.fetch;
  window.fetch = function (...args) {
    const result = _fetch.apply(this, args);

    try {
      const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      const isCartMutation =
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear');

      if (isCartMutation) {
        result.then(() => scheduleRefresh()).catch(() => {});
      }
    } catch (_) {}

    return result;
  };

  document.addEventListener('DOMContentLoaded', () => {
    refreshInCartBadges();
  });

  ['cart:updated', 'cart:refresh', 'ajaxCart:updated', 'theme:cart:updated'].forEach((evt) => {
    document.addEventListener(evt, () => scheduleRefresh());
  });

  window.__refreshInCartBadges = scheduleRefresh;
})();

(function () {
  function applyDefaultLayout(root = document) {
    const productsList = root.getElementById('ProductsList');
    if (!productsList) return;

    const defaultLayout = productsList.dataset.defaultLayout;
    if (!defaultLayout) return;

    const gridButton = document.querySelector('[data-layout-mode="grid"]');
    const listButton = document.querySelector('[data-layout-mode="list"]');

    const alreadyInitialised = productsList.dataset.layoutInitialised === 'true';

    const reveal = () => {
      productsList.style.opacity = '1';
      productsList.dataset.layoutInitialised = 'true';
    };

    if (defaultLayout === 'list') {
      if (!alreadyInitialised) {
        productsList.style.opacity = '0';
      }

      if (listButton) listButton.click();

      requestAnimationFrame(reveal);
      setTimeout(reveal, 150);
      return;
    }

    if (gridButton) gridButton.click();
    reveal();
  }

  function observeCollectionUpdates() {
    const gridContainer =
      document.getElementById('ProductGridContainer') ||
      document.getElementById('ProductGridWrapper');

    if (!gridContainer) return;

    let raf = null;

    const observer = new MutationObserver(() => {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        applyDefaultLayout(document);
        if (window.__refreshInCartBadges) window.__refreshInCartBadges();
      });
    });

    observer.observe(gridContainer, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyDefaultLayout(document);
    observeCollectionUpdates();
  });

  document.addEventListener('shopify:section:load', () => {
    applyDefaultLayout(document);
    if (window.__refreshInCartBadges) window.__refreshInCartBadges();
  });
})();